import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import store from './store'

const About = () => import('@/pages/About')
const Consulting = () => import('@/pages/Consulting')
const DataDictionary = () => import('@/pages/DataDictionary')
const EmailVerified = () => import('@/pages/EmailVerified')
const House = () => import('@/pages/House')
const HouseLanding = () => import('@/pages/HouseLanding')
const Login = () => import('@/pages/Login')
const President = () => import('@/pages/President')
const PresidentialLanding = () => import('@/pages/PresidentialLanding')
const Methodology = () => import('@/pages/Methodology')
const Results = () => import('@/pages/Results')
const Senate = () => import('@/pages/Senate')
const SenateLanding = () => import('@/pages/SenateLanding')
// const SenateRunoff = () => import('@/pages/SenateRunoff')
// const SenateRunoffLanding = () => import('@/pages/SenateRunoffLanding')

Vue.use(Router)
Vue.use(Meta)

const routes = [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
          auth: false
      }
    }, {
      path: '/email-verified',
      name: 'email_verified',
      component: EmailVerified
    }, {
      path: '/about',
      name: 'about',
      component: About
    }, {
      path: '/methodology',
      name: 'methodology',
      component: Methodology
    }, {
      path: '/consulting',
      name: 'consulting',
      component: Consulting
    }, {
      path: '/data-dictionary',
      name: 'data_dictionary',
      component: DataDictionary,
      meta: {
          fluid: true
      }
    }, {
      path: '/house',
      name: 'house_landing',
      component: HouseLanding
    }, {
      path: '/house/:raceId',
      name: 'house',
      component: House
    }, {
      path: '/results',
      name: 'results',
      component: Results
    }, {
      path: '/senate',
      name: 'senate_landing',
      component: SenateLanding
    }, {
      path: '/senate/:raceId',
      name: 'senate',
      component: Senate
    }, {
    //   path: '/senate_runoff',
    //   name: 'senate_runoff_landing',
    //   component: SenateRunoffLanding
    // }, {
    //   path: '/senate_runoff/:raceId',
    //   name: 'senate_runoff',
    //   component: SenateRunoff
    // }, {
      path: '/president',
      name: 'presidential_landing',
      component: PresidentialLanding
    }, {
      path: '/president/:raceId',
      name: 'president',
      component: President
    }, {
      path: '*',
      redirect: '/president'
    }
]

const router = new Router({
    mode: 'history',
    routes,
    scrollBehavior() {
        // if (to.hash) {
        //   return new Promise((resolve) => {
        //     setTimeout(() => {
        //       resolve({
        //         selector: to.hash,
        //         // offset: { x: 0, y: 80 }
        //       })
        //     }, 300)
        //   })
        // }
        return {x: 0, y: 0}
    }
})

router.beforeEach((to, from, next) => {
    store.dispatch('ux/cancelPendingRequests')

    if (to.hash.startsWith('#access_token') === true) {
      const RE = /access_token=(.[^&]*)&/
      const token = to.hash.match(RE)[1]
      Vue.$auth.login(token)
    }

    const redirect = to.query.redirect
    if (typeof redirect !== 'undefined') {
      const parts = redirect
        .replace(window.location.origin, '')
        .split('/')
        .filter(v => v)
      if (parts.length === 2) {
        next(`/${parts[0]}/${parts[1]}`)
      } else {
        next()
      }
    } else if (
      to.path === '/login' &&
      (Vue.$auth.token || Vue.$auth.authenticated)
    ) {
      next('/')
    } else {
      next()
    }
})

export default router
